import React from "react";

interface CounterProps {
  amount: number;
  onIncrement: () => void;
  onDecrement: () => void;
  onAmountChange: (amount: number) => void;
  disabled?: boolean;
}

const Counter: React.FC<CounterProps> = ({
  amount,
  onIncrement,
  onDecrement,
  onAmountChange,
  disabled = false,
}) => {
  const handleAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;

    if (nextValue === "") {
      onAmountChange(0);
      return;
    }

    if (/^\d+$/.test(nextValue)) {
      onAmountChange(Number(nextValue));
    }
  };

  return (
    <div className="align-content-center justify-content-start d-flex col">
      <button className="counterBtn" onClick={onDecrement} disabled={disabled}>
        -
      </button>
      <span className="yellowTxt col-auto d-flex m-1 align-items-center">
        <p className="m-1">GBP</p>
        <input
          className="counter m-1 bg-transparent border-0 yellowTxt"
          inputMode="numeric"
          pattern="[0-9]*"
          value={amount}
          onChange={handleAmountChange}
          disabled={disabled}
          style={{ width: "90px" }}
        />
      </span>
      <button className="counterBtn" onClick={onIncrement} disabled={disabled}>
        +
      </button>
    </div>
  );
};

export default Counter;
